<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listAccountTypes"
        :title-table="$t('Account Types')"
        module="accountTypeSettingsModule"
        sort-name="descricao"
        add-permission="ROLE_TIPO_CONTA_INSERIR"
        view-permission="ROLE_TIPO_CONTA_CONSULTAR"
        edit-permission="ROLE_TIPO_CONTA_ATUALIZAR"
        delete-permission="ROLE_TIPO_CONTA_DELETAR"
        @add="addNew"
        @edit="edit"
      />
      <FormAccountType
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormAccountType from './forms/FormAccountType.vue'

export default {
  name: 'AccountType',
  components: {
    BRow,
    BCol,
    TableComponents,
    FormAccountType,
  },
  computed: {
    ...mapState('accountTypeSettingsModule', {
      listAccountTypes: state => state.listAccountTypes,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: this.$t('id'),
          field: 'id',
        },
        {
          label: this.$t('Description'),
          field: 'descricao',
        },
        {
          label: this.$t('Action'),
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch(
        'accountTypeSettingsModule/prepareToEditAccountType',
        data,
      )
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
